import { getSearchParams } from '@wix/package-picker-shared';
import { useCurrentModule } from '../../components/ModuleProvider';
import { EclipsePackagePickerSteps } from '../../types/types';
import { eclipseServerData } from '../../utils';
import { getFreeDomainTooltipKey as getFreeDomainTooltipKeyUtil } from '../../utils/freeDomainTooltipKey';
import { DOMAIN_INTENT_REFERRAL_VALUES, DomainIntentType, getDomainIntentType, isBaseDomainPurchaseIntentReferral } from '../../utils/domainIntentReferrals';
const FUNNEL_PATH = '/premium-domains/premium-funnel';
export const useDomainIntent = () => {
  const module = useCurrentModule();
  const {
    domainName,
    showDomain: showDomainParam,
    referralAdditionalInfo,
    referrer,
    allSearchParams
  } = getSearchParams();
  const {
    experiments
  } = module.internals.experiments.hooks.useExperiments();
  const isShowDomainExperimentEnabled = experiments.isEnabled('specs.premium.DisplayDomainNameInDomainFeature');
  const intentType = getDomainIntentType(referralAdditionalInfo);
  const isDomainIntent = intentType !== undefined;
  const isConnectIntent = intentType === DomainIntentType.CONNECT || intentType === DomainIntentType.CONNECT_DROPSHIPPING || intentType === DomainIntentType.CONNECT_FUNNEL;
  const isPurchaseIntent = intentType === DomainIntentType.PURCHASE || intentType === DomainIntentType.PURCHASE_DROPSHIPPING || intentType === DomainIntentType.PURCHASE_STOREFRONT || intentType === DomainIntentType.PURCHASE_FUNNEL;
  const showDomain = showDomainParam === true && isShowDomainExperimentEnabled;
  const shouldShowDomainFirst = showDomain && isPurchaseIntent && experiments.isEnabled('specs.premium.domainFirstItemPurchaseIntent');
  const isDisplayDomainNameInTitleEnabled = experiments.isEnabled('specs.premium.displayDomainNameInTitle');
  const currentStep = module.internals.hooks.useCurrentStep();
  const isProductsPage = currentStep === EclipsePackagePickerSteps.SELECT_PLAN || currentStep === EclipsePackagePickerSteps.ANY;
  const shouldShowDomainNameInTitle = isBaseDomainPurchaseIntentReferral(referralAdditionalInfo) && showDomainParam === true && !!domainName && isDisplayDomainNameInTitleEnabled && isProductsPage;
  const isStorefrontReferrerWithDomain = referralAdditionalInfo === DOMAIN_INTENT_REFERRAL_VALUES[DomainIntentType.PURCHASE_STOREFRONT] && showDomainParam === true && referrer === 'storefront';
  const isConnectFunnel = intentType === DomainIntentType.CONNECT_FUNNEL;
  const isInFunnel = (intentType === DomainIntentType.PURCHASE_FUNNEL || isConnectFunnel) && !!domainName;
  const getFunnelParams = () => {
    const referrerUrl = document.referrer ? new URL(document.referrer) : undefined;
    return referrerUrl != null && referrerUrl.pathname.includes(FUNNEL_PATH) ? referrerUrl.searchParams : allSearchParams;
  };
  const getFunnelBackUrl = () => {
    const params = new URLSearchParams(getFunnelParams());
    const siteGuid = params.get('siteGuid');
    if (siteGuid) {
      params.set('msid', siteGuid);
    }
    params.set('step', isConnectFunnel ? 'search' : 'split');
    if (isConnectFunnel && domainName) {
      params.set('q', domainName);
    }
    return `${FUNNEL_PATH}/?${params.toString()}`;
  };
  const backToFunnel = () => window.location.assign(getFunnelBackUrl());
  const isMatchDomainCycleEnabled = experiments.isEnabled('matchDomainCycleToPremiumCycle');
  const getFreeDomainTooltipKey = featureNameTranslationKey => getFreeDomainTooltipKeyUtil({
    featureNameTranslationKey,
    geo: eclipseServerData.get().geo,
    referralAdditionalInfo,
    domainName,
    isDisplayDomainExperimentEnabled: isShowDomainExperimentEnabled,
    isMatchDomainCycleEnabled
  });
  return {
    isDomainIntent,
    domainName,
    showDomain,
    intentType,
    isConnectIntent,
    isPurchaseIntent,
    shouldShowDomainFirst,
    shouldShowDomainNameInTitle,
    isStorefrontReferrerWithDomain,
    getFreeDomainTooltipKey,
    isInFunnel,
    backToFunnel
  };
};
//# sourceMappingURL=useDomainIntent.js.map